<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length > 2 ? "UPDATE LINK" : "LINK NEW" }}
        RECEPTION/PURCHASE ORDER
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <div v-if="Object.entries(this.data).length <= 2" class="vx-row w-full">
          <div class="vx-col w-full" style="font-size: 90%">
            <br />Reception/Purchase order
            <v-select
              autocomplete
              :options="data_option_operation"
              v-model="linkedOperationId"
            />
          </div>
        </div>

        <br v-if="Object.entries(this.data).length <= 2" />
        <hr v-if="Object.entries(this.data).length <= 2" class="mt-5 w-full" />
        <!--<div class="vx-row w-full">
          <div class="vx-col w-1/2">
            <vs-input
              label="Aviz Serie"
              v-model="dataAvizSerie"
              class="mt-4 w-full"
              style="
                background-color: #ffff99;
                border: 1px solid #ffff99;
                border-radius: 5px;
              "
              name="Aviz Serie"
            />
          </div>
          <div class="vx-col w-1/2">
            <vs-input
              label="Aviz Number"
              v-model="dataAvizNumber"
              class="mt-4 w-full"
              style="
                background-color: #ffff99;
                border: 1px solid #ffff99;
                border-radius: 5px;
              "
              name="Aviz Number"
            />
          </div>
        </div>-->
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>
 
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "@/axios.js";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import vSelect from "vue-select";
import moment from "moment";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
  data() {
    return {
      dataIdInvoice: null,
      dataIdTransport: null,
      data_option_operation: [],
      linkedOperationId: null,
      dateTransport: null,
      dataAvizNumber: null,
      dataAvizSerie: null,
      isedit: false,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 2) {
        // ADD NEW
        this.initValues();
        this.$validator.reset();
        this.dateTransport = this.data.datetransport;
        this.dataIdTransport = this.data.idtransport;
        this.isedit = false;
        //this.dataAvizSerie = moment(this.dateTransport).format("YYYY")
        //this.getLastNrFromSerie(moment(this.dateTransport).format("YYYY"))
        this.getOptionsOperations();
      } else {
        // UPDATE
        this.dateTransport = this.data.datetransport;
        //this.dataAvizNumber = this.data.aviz_number;
        //this.dataAvizSerie = this.data.aviz_serie;
        //this.dataIdInvoice = this.data.id;
        this.dataIdTransport = this.data.idtransport;
        this.isedit = true;
        this.getOptionsOperations();
        this.initValues();
      }
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    isFormValid() {
      return !this.errors.any();
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    async getLastNrFromSerie(serie) {
      axios
        .get(
          "/transport/getlastnrfromserie/" +
            serie
        )
        .then((response) => {
          this.dataAvizNumber = response.data.last
          if (!this.dataAvizNumber) this.dataAvizNumber = 1
        });
    },
    async getOptionsOperations() {
      axios
        .get(
          "/getcloseoperationentrant/" +
            moment(this.dateTransport).format("YYYY-MM-DD")
        )
        .then((response) => {
          this.data_option_operation = [...response.data];
        });
    },
    initValues() {
      if (this.data.id) return;
      (this.dataProductCategoryId = ""),
        (this.dataAvizNumber = ""),
        (this.dataAvizSerie = ""),
        (this.data_option_operation= []);
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var obj = {};
          if (this.linkedOperationId) {
            // isnew
            obj = {
              idtransport: this.dataIdTransport,
              idinvoice: this.linkedOperationId.value,
              aviz_serie: this.dataAvizSerie,
              aviz_number: this.dataAvizNumber,
              delete: false,
            };
            this.$store
              .dispatch("operationList/linkOperationToTransportFromAdd", obj)
              .then((response) => {
                this.$vs.notify({
                  color: "success",
                  title: "Transport Linked",
                  text: `The selected Reception/Purchase order is now on this transport (aviz ${this.dataAvizSerie || "?"} ${this.dataAvizNumber || "?"}).`,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                // Un rattachement d'aviz qui echoue en silence, c'est un devis
                // qu'on croit sur le camion et qui n'y est pas.
                console.error(err);
                const data = err.response && err.response.data;
                this.$vs.notify({
                  color: "danger",
                  title: "NOT linked to the transport",
                  text: (data && (data.message || data.error)) || err.message || "The server refused the link.",
                  time: 12000,
                });
              });
          } else {
            // isedit
            obj = {
              idtransport: this.dataIdTransport,
              idinvoice: this.dataIdInvoice,
              aviz_serie: this.dataAvizSerie,
              aviz_number: this.dataAvizNumber,
              delete: false,
            };
            this.$store
              .dispatch("operationList/linkOperationToTransport", obj)
              .then((response) => {
                this.$vs.notify({
                  color: "success",
                  title: "Transport Linked",
                  text: `The selected Reception/Purchase order is now on this transport (aviz ${this.dataAvizSerie || "?"} ${this.dataAvizNumber || "?"}).`,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                // Un rattachement d'aviz qui echoue en silence, c'est un devis
                // qu'on croit sur le camion et qui n'y est pas.
                console.error(err);
                const data = err.response && err.response.data;
                this.$vs.notify({
                  color: "danger",
                  title: "NOT linked to the transport",
                  text: (data && (data.message || data.error)) || err.message || "The server refused the link.",
                  time: 12000,
                });
              });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
